import { AbstractSystem } from '../entities_engine/abstract_system';
import { ComponentIndex } from '../entities_engine/component_index';
import { EntitiesEngine } from '../entities_engine/entities_engine';
import { Entity } from '../entities_engine/entity';
import { EntityCacheHolder } from '../game_components/entity_cache_holder';
import { ListSet } from '../utils/list_set';

export abstract class BaseSystem extends AbstractSystem {
  private _entities: ListSet<Entity>;
  protected readonly entityCacheHolder: EntityCacheHolder;

  protected constructor(engine: EntitiesEngine, entityCacheHolder: EntityCacheHolder) {
    super(engine);
    this.entityCacheHolder = entityCacheHolder;
  }

  public get entities(): ListSet<Entity> {
    return this._entities;
  }

  public withInitialize(): this {
    const filter = this.engine.getFilterByIndex(this.getIndexesForFilter());
    this._entities = this.engine.getEntities(filter);
    return this;
  }

  public updateImpl(dt: number): void {
    const entities = this._entities.list;
    for (let i = 0; i < entities.length; i++) {
      this.processEntity(entities[i], dt);
    }
  }

  public abstract getIndexesForFilter(): ComponentIndex[];

  public processEntity(_entity: Entity, _dt: number): void { }
}
